/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DiscordMessageAuthor } from './DiscordMessageAuthor';
import {
    DiscordMessageAuthorFromJSON,
    DiscordMessageAuthorFromJSONTyped,
    DiscordMessageAuthorToJSON,
    DiscordMessageAuthorToJSONTyped,
} from './DiscordMessageAuthor';

/**
 * 
 * @export
 * @interface DiscordMessageBody
 */
export interface DiscordMessageBody {
    /**
     * Discord message ID
     * @type {string}
     * @memberof DiscordMessageBody
     */
    id: string;
    /**
     * Discord channel ID
     * @type {string}
     * @memberof DiscordMessageBody
     */
    channelId: string;
    /**
     * Discord guild/server ID
     * @type {string}
     * @memberof DiscordMessageBody
     */
    guildId: string;
    /**
     * Message content
     * @type {string}
     * @memberof DiscordMessageBody
     */
    content: string;
    /**
     * 
     * @type {Date}
     * @memberof DiscordMessageBody
     */
    timestamp: Date;
    /**
     * 
     * @type {DiscordMessageAuthor}
     * @memberof DiscordMessageBody
     */
    author: DiscordMessageAuthor;
    /**
     * 
     * @type {Array<object>}
     * @memberof DiscordMessageBody
     */
    attachments?: Array<object>;
    /**
     * 
     * @type {Array<object>}
     * @memberof DiscordMessageBody
     */
    embeds?: Array<object>;
    /**
     * 
     * @type {Date}
     * @memberof DiscordMessageBody
     */
    editedTimestamp?: Date | null;
}

/**
 * Check if a given object implements the DiscordMessageBody interface.
 */
export function instanceOfDiscordMessageBody(value: object): value is DiscordMessageBody {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('channelId' in value) || value['channelId'] === undefined) return false;
    if (!('guildId' in value) || value['guildId'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
    if (!('author' in value) || value['author'] === undefined) return false;
    return true;
}

export function DiscordMessageBodyFromJSON(json: any): DiscordMessageBody {
    return DiscordMessageBodyFromJSONTyped(json, false);
}

export function DiscordMessageBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscordMessageBody {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'channelId': json['channelId'],
        'guildId': json['guildId'],
        'content': json['content'],
        'timestamp': (new Date(json['timestamp'])),
        'author': DiscordMessageAuthorFromJSON(json['author']),
        'attachments': json['attachments'] == null ? undefined : json['attachments'],
        'embeds': json['embeds'] == null ? undefined : json['embeds'],
        'editedTimestamp': json['editedTimestamp'] == null ? undefined : (new Date(json['editedTimestamp'])),
    };
}

export function DiscordMessageBodyToJSON(json: any): DiscordMessageBody {
    return DiscordMessageBodyToJSONTyped(json, false);
}

export function DiscordMessageBodyToJSONTyped(value?: DiscordMessageBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'channelId': value['channelId'],
        'guildId': value['guildId'],
        'content': value['content'],
        'timestamp': ((value['timestamp']).toISOString()),
        'author': DiscordMessageAuthorToJSON(value['author']),
        'attachments': value['attachments'],
        'embeds': value['embeds'],
        'editedTimestamp': value['editedTimestamp'] === null ? null : ((value['editedTimestamp'] as any)?.toISOString()),
    };
}

